/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Projection_Continue_ActionInputs */

const en_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fund my plan`)
};

const de_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meinen Plan finanzieren`)
};

const pt_br2_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financiar meu plano`)
};

const tr_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planıma para yatır`)
};

const zh_cn2_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为我的计划注资`)
};

const zh_hk2_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為我的計劃注資`)
};

const ko_kr2_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 플랜에 자금 넣기`)
};

const ru_ru2_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пополнить мой план`)
};

const es_419_onboarding_v1_projection_continue_action = /** @type {(inputs: Onboarding_V1_Projection_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financiar mi plan`)
};

/**
* | output |
* | --- |
* | "Fund my plan" |
*
* @param {Onboarding_V1_Projection_Continue_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_continue_action = /** @type {((inputs?: Onboarding_V1_Projection_Continue_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_Continue_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_continue_action(inputs)
	if (locale === "de") return de_onboarding_v1_projection_continue_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_continue_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_continue_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_continue_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_continue_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_continue_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_continue_action(inputs)
	return es_419_onboarding_v1_projection_continue_action(inputs)
});